const employmentHistory = [
  {
    title: "Senior .NET Developer",
    company: "Global",
    location: "London, England, United Kingdom (Hybrid)",
    duration: "July 2024 - Present",
    responsibilities: [
      "Maintain and support legacy .NET Commercial Radio systems, reducing technical debt and improving reliability, scalability, and maintainability.",
      "Design and implement microservices with .NET, deployed on Kubernetes (EKS), gradually replacing legacy applications and modernising critical systems.",
      "Provision and manage cloud infrastructure using Terraform, ensuring consistent, version-controlled deployments across multiple environments.",
      "Provide mentorship, coaching, and career development guidance to engineers, including conducting performance reviews and setting growth objectives.",
      "Collaborate with product and engineering stakeholders to define architecture, align technical efforts with business objectives, and drive end-to-end project delivery.",
      "Champion engineering excellence by mentoring, pair programming, and establishing best practices, including the practical use of AI-assisted development tools.",
      "Lead code reviews and contribute to continuous delivery pipelines, improving deployment velocity, code quality, and team effectiveness."
    ],
  },
  {
    title: "Senior Lead Software Engineer",
    company: "One Beyond Ltd",
    location: "London, England, United Kingdom (Remote)",
    duration: "April 2023 - July 2024",
    responsibilities: [
      "Led a team of software engineers in the design, development, and deployment of web applications using the .NET stack, Vue.js, and Microsoft Azure.",
      "Architected and implemented scalable, cloud-native solutions leveraging Azure services, Kubernetes, and Terraform for infrastructure as code.",
      "Worked closely with product managers and stakeholders to gather requirements, prioritise tasks, and deliver high-quality software on schedule.",
      "Mentored junior and mid-level developers, providing guidance on coding standards, best practices, and professional growth.",
      "Conducted code reviews, drove process improvements, and promoted a culture of engineering excellence and continuous learning.",
      "Contributed to the company's most profitable project at the time, delivering a robust, maintainable system that drove measurable impact for the client."
    ],
  },
  {
    title: "Senior Software Engineer",
    company: "One Beyond Ltd",
    location: "London, England, United Kingdom (Remote)",
    duration: "January 2023 - April 2023",
    responsibilities: [
      "Owned the development and maintenance of backend services, ensuring scalability, reliability, and performance.",
      "Designed and implemented front-end components and user interfaces using Vue.js, improving usability and feature adoption.",
      "Integrated third-party APIs and services to extend application functionality and support business needs.",
      "Collaborated with cross-functional teams to troubleshoot issues, optimise system performance, and deliver high-quality features.",
      "Contributed to Agile processes including sprint planning, daily stand-ups, and retrospectives, helping the team maintain velocity and quality."
    ],
  },  
  {
    title: "Software Engineer",
    company: "One Beyond Ltd",
    location: "London, England, United Kingdom (Remote)",
    duration: "November 2021 - December 2022",
    responsibilities: [
      "Developed and maintained a microservices architecture using .NET Core and Docker, delivering scalable and reliable backend services.",
      "Implemented secure authentication and authorization using Azure Active Directory and OAuth 2.0.",
      "Designed and optimised database schemas and queries for performance and scalability with Entity Framework Core and Azure SQL Database.",
      "Automated deployment processes and managed CI/CD pipelines using Azure DevOps and GitHub Actions, reducing release times and errors.",
      "Collaborated closely with QA engineers to develop automated load testing scripts, improving software quality and system performance.",
      "Participated in code reviews and contributed to engineering best practices to enhance maintainability and team efficiency."
    ],
  },
  {
    title: "Software Developer",
    company: "Boston Digital Ltd",
    location: "London, England, United Kingdom",
    duration: "October 2018 - November 2021 (In office)",
    responsibilities: [
      "Led the architecture and development of a double-entry accounting system, managing user transactions and earnings across multiple services.",
      "Designed and implemented machine learning models using Azure Cognitive Services to segment users and enhance marketing effectiveness.",
      "Developed and maintained backend microservices and APIs using .NET, ensuring high performance and reliability.",
      "Conducted code reviews, mentored junior developers, and contributed to improving engineering practices and team standards.",
      "Collaborated with product and business teams to define requirements and deliver scalable, maintainable solutions."
    ],
  },  
  {
    title: "Junior Software Developer",
    company: "Boston Digital Ltd",
    location: "London, England, United Kingdom",
    duration: "July 2018 - October 2018 (In office)",
    responsibilities: [
      "Planned, developed, and delivered .NET-based microservices for production backend systems.",
      "Took ownership of features across backend services, web SPAs (Vue.js), and mobile applications built with Xamarin.Forms.",
      "Designed and maintained CI pipelines using Azure DevOps and App Centre to improve build and release reliability.",
      "Actively supported production systems, including diagnosing issues and contributing to fixes while maintaining service availability.",
      "Presented and demonstrated new product features to stakeholders during bi-weekly business demos."
    ],
  },
  {
    title: "Apprentice Software Developer",
    company: "Boston Digital Ltd",
    location: "London, England, United Kingdom",
    duration: "July 2017 - July 2018 (In Office)",
    responsibilities: [
      "Completed a two-year Level 4 Software Development apprenticeship one year early.",
      "Helped break down legacy applications into .NET microservices while maintaining live production systems.",
      "Developed multiple single-page applications using Vue.js, including custom payment integrations with Stripe.",
      "Contributed to the design and development of a mobile tracking application using Xamarin.Forms, generating approximately £100k per month in subscription revenue.",
      "Produced and maintained technical and functional documentation."
    ],
  },
];

export { employmentHistory };
